__turbopack_context__.v({
  "clickable": "ListingCard-module__cbn2-G__clickable",
  "container": "ListingCard-module__cbn2-G__container",
  "content": "ListingCard-module__cbn2-G__content",
  "dot-flashing": "ListingCard-module__cbn2-G__dot-flashing",
  "dotFlashing": "ListingCard-module__cbn2-G__dotFlashing",
  "footer": "ListingCard-module__cbn2-G__footer",
  "fullHeight": "ListingCard-module__cbn2-G__fullHeight",
  "fullWidth": "ListingCard-module__cbn2-G__fullWidth",
  "layoutHorizontal": "ListingCard-module__cbn2-G__layoutHorizontal",
  "loading": "ListingCard-module__cbn2-G__loading",
  "noBackground": "ListingCard-module__cbn2-G__noBackground",
  "selected": "ListingCard-module__cbn2-G__selected",
  "title": "ListingCard-module__cbn2-G__title",
});
